import { PersonalInformationForm } from '@features/profile/components/personal-information/PersonalInformationForm';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

const PersonalInformationRoute = React.memo((): React.ReactElement => {
  return (
    <>
      <PersonalInformationForm />
      <Outlet />
    </>
  );
});

PersonalInformationRoute.displayName = 'PersonalInformationRoute';

export { PersonalInformationRoute };
